import { ReactElement } from "react";
import { Navigate } from "react-router-dom";
import { useAppData } from "../../contexts/AppContext";
import { podeAbrirAutomacoes } from "../../routes/routeAccess";

/**
 * Guarda da rota `/automacoes` — GEN-4080.
 *
 * O `RequirePermission` só sabe exigir UMA permissão; aqui são duas portas (`automations.read` com o
 * produto, ou `alerts.read` — ver `podeAbrirAutomacoes`), as duas atrás da liberação de Automações para
 * o cliente (GEN-4080 r4: sem ela, volta para a home como as demais rotas sem acesso). A espera pelos dados é a
 * mesma do `RequirePermission`: as flags de produto chegam depois do mount, e negar antes delas
 * mandaria um F5/deep-link para o Dashboard.
 */
export function RequireAutomacoesAccess({ children }: { children: ReactElement }) {
  const data = useAppData();
  if (!data.currentClient || !data.certificatesLoaded) return null;
  if (!podeAbrirAutomacoes(data)) return <Navigate to="/" replace />;
  return children;
}
